import Config from 'arbitrip-common/client/utils/Config';
import { addUtmSourceToUrl } from 'arbitrip-common/client/utils/UtmSource';
import { addUtmContentToUrl } from 'arbitrip-common/client/utils/UtmContent';
import ApiURLs from '@/utils/ApiURLs';

const RESULTS_REF_URL_PARAMS = [
    'place_id',
    'hotel_id',
    'check_in',
    'check_out',
    'guests',
    'children_ages',
    'rooms',
    'search_token',
];

export function buildLoginUrl({ filterResultsRefUrl = false } = {}) {
    const baseLoginUrl = Config.is_letstay ? ApiURLs.LETSTAY_LOGIN : Config.prod ? '/login' : ApiURLs.LOGIN;
    const refUrl = new URL(window.location.href);

    if (filterResultsRefUrl && refUrl.pathname === '/results') {
        const searchParams = new URLSearchParams();

        RESULTS_REF_URL_PARAMS.forEach((key) => {
            const value = refUrl.searchParams.get(key);
            if (value !== null) searchParams.set(key, value);
        });

        refUrl.search = searchParams.toString();
    }

    const loginParams = new URLSearchParams({ ref_url: refUrl.toString() });
    return addUtmContentToUrl(addUtmSourceToUrl(`${baseLoginUrl}?${loginParams.toString()}`));
}
